import { useEffect, useState } from 'react';

/**
 * Track a CSS media query in React. Used for the desktop breakpoint: the same Mini App
 * opens on a phone and in Telegram Desktop/Web, and the wide layout only makes sense on
 * the latter. Subscribes to changes so rotating a tablet or resizing a window re-lays out.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false,
  );

  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = () => setMatches(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
